module.exports = __webpack_public_path__ + "img/couples_06_V.1d7254b4.webp";